export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

export const ISSUANCE_RATE_MONTH = process.env.ISSUANCE_RATE_MONTH || 720; // Time circles
export const PATHFINDER_HOPS_DEFAULT = 3;
export const NEEDED_TRUST_CONNECTIONS = 1;

export const ABOUT_URL = 'https://www.aboutcircles.com';
export const BUG_REPORTING_URL = 'mailto:support@aboutcircles.com';
export const DISCORD_URL = 'https://discord.com/invite/aboutcircles';
export const METRI_URL = 'https://app.metri.xyz/';
export const EMAIL_URL = 'mailto:hello@aboutcircles.com';
export const FACEBOOK_URL = 'https://facebook.com/CirclesUBI';
export const FAQ_URL = 'https://www.aboutcircles.com/faq';
export const FAQ_URL_DELETION =
  'https://joincircles.net/faq/profile-data-deletion/';
export const FAQ_TRANSITIVE_TRANSFERS_URL =
  'https://github.com/CirclesUBI/whitepaper?tab=readme-ov-file#transitive-exchange';
export const PRIVACY_LEGAL_URL = 'https://www.gnosis.io/privacy-policy';
export const TELEGRAM_URL = 'https://t.me/about_circles';
export const TERMS_URL =
  'https://www.aboutcircles.com/circles-garden-terms-of-service';
export const TWITTER_URL = 'https://twitter.com/aboutcircles';

export const SAFE_LAST_VERSION = '1.3.0';
export const SAFE_CRC_VERSION = '1.1.1';

export const FILTER_TRANSACTION_ALL = 'FILTER_TRANSACTION_ALL';
export const FILTER_TRANSACTION_SENT = 'FILTER_TRANSACTION_SENT';
export const FILTER_TRANSACTION_RECEIVED = 'FILTER_TRANSACTION_RECEIVED';
